import './index.less'
import { EyeOutlined, CloudDownloadOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '@/hooks'
import {
  setAnalysisImageId,
  setAnalysisWorkId
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import { getImagesOfWorkRequest, SRC_URL } from '@/server'
import { useEffect, useRef, useState } from 'react'
import { SelectWorkList } from '@/components/SelectWorkList'
import { setSelectedPage } from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import * as d3 from 'd3'
interface OverviewTypeProps {
  setComponent: Function
}

//浏览页面
export function OverViewType(props: OverviewTypeProps) {
  const token = useAppSelector((state) => state.login.token)
  const dispatch = useAppDispatch()
  //缓存中的tagsList
  const _tagsList = useAppSelector((state) => state.overviewTagsList.tagsList)
  const { setComponent } = props
  //画作列表
  const searchResultList = useAppSelector((state) => state.overviewTypeList.overviewList)
  //一页的容量
  const size = 8
  const listBodyRef = useRef<HTMLDivElement>(null)
  const [listItemSize, setListItemSize] = useState({
    width: 299,
    height: 377,
    titleSize: 18,
    metaSize: 12,
    textGap: 10
  })
  // 待选列表
  const [showWorkList, setShowWorkList] = useState<{ id: string; imageId: string; src: string }[]>(
    []
  )
  // 每张图的三角形icon是否展示
  const [iconArr, setIconArr] = useState<boolean[]>(Array(size).fill(false))
  //画作列表中，画作鼠标点击事件
  const handleSelectItem = function (id: string, index: number) {
    dispatch(setSelectedPage(0))
    getImagesOfWorkRequest({ workId: id }, token).then((res) => {
      const list = res.data.content.map((work) => {
        return {
          imageId: work.imageid,
          src: work.fullpath
        }
      })
      if (list.length === 1) {
        dispatch(setAnalysisWorkId(id))
        dispatch(setAnalysisImageId(list[0].imageId))
        setComponent(2)
      } else {
        getImagesOfWorkRequest({ workId: id }, token).then((res) => {
          const list = res.data.content.map((work) => {
            return {
              id,
              imageId: work.imageid,
              src: work.fullpath
            }
          })
          setShowWorkList(list)
          // 需要展示待选列表
          if (list.length > 1) {
            const selectWorkListDiv = d3.select('#select-work-list')
            const itemHeight = d3.select('.list-item')._groups[0][0].clientHeight

            // 设置待选列表展示的位置，index < 5则显示在下方，index>=5则显示在上方
            if (index < size / 2)
              selectWorkListDiv.style('top', '').style('bottom', itemHeight / 2 + 'px')
            else selectWorkListDiv.style('top', itemHeight / 2.5 + 'px').style('bottom', '')
            // 设置三角形icon的显隐
            setIconArr(
              iconArr.map((_icon, i) => {
                if (i !== index) return false
                else return true
              })
            )
          } else {
            setIconArr(Array(size).fill(false))
          }
        })
      }
    })
  }

  //点击待选列表外部，清除待选列表
  useEffect(() => {
    const func = (e: any) => {
      const selectWorkListDiv = document.querySelector('#select-work-list')
      if (selectWorkListDiv && !selectWorkListDiv.contains(e.target)) {
        setShowWorkList([])
        setIconArr(Array(size).fill(false))
      }
    }
    document.addEventListener('mousedown', func)
    return () => {
      document.removeEventListener('mousedown', func)
    }
  })
  useEffect(() => {
    const listBody = listBodyRef.current
    if (!listBody) return

    const updateListItemSize = () => {
      const styles = window.getComputedStyle(listBody)
      const columnGap = parseFloat(styles.columnGap) || 0
      const rowGap = parseFloat(styles.rowGap) || 0
      const paddingLeft = parseFloat(styles.paddingLeft) || 0
      const paddingRight = parseFloat(styles.paddingRight) || 0
      const availableWidth = listBody.clientWidth - paddingLeft - paddingRight - columnGap * 3
      const availableHeight = listBody.clientHeight - rowGap
      const widthFromContainer = availableWidth / 4
      const heightFromRatio = widthFromContainer * (377 / 299)
      const heightFromContainer = availableHeight / 2
      const itemHeight = Math.min(heightFromRatio, heightFromContainer)
      const itemWidth = itemHeight * (299 / 377)
      const itemScale = itemHeight / 377

      setListItemSize({
        width: Math.max(0, itemWidth),
        height: Math.max(0, itemHeight),
        titleSize: Math.max(12, 18 * itemScale),
        metaSize: Math.max(10, 12 * itemScale),
        textGap: Math.max(4, 10 * itemScale)
      })
    }

    updateListItemSize()
    const resizeObserver = new ResizeObserver(updateListItemSize)
    resizeObserver.observe(listBody)
    return () => {
      resizeObserver.disconnect()
    }
  }, [])
  return (
    <>
      <div
        className='overview-type-list-body'
        ref={listBodyRef}
        style={
          {
            '--overview-list-item-width': `${listItemSize.width}px`,
            '--overview-list-item-height': `${listItemSize.height}px`,
            '--overview-list-title-size': `${listItemSize.titleSize}px`,
            '--overview-list-meta-size': `${listItemSize.metaSize}px`,
            '--overview-list-text-gap': `${listItemSize.textGap}px`
          } as React.CSSProperties
        }
      >
        {searchResultList.map((painting, index) => {
          return (
            <>
              <div className='list-item' onClick={() => handleSelectItem(painting.workId, index)}>
                <div
                  className={`tri-icon-${index < size / 2 ? 'top' : 'bottom'}`}
                  style={{ display: iconArr[index] ? 'block' : 'none' }}
                ></div>
                <img src={painting.src ? SRC_URL + painting.src : ''} alt='' />
                <div className='item-desc'>
                  <div className='item-pos-box'>
                    <div className='item-name' title={painting.workName}>
                      {painting.workName}
                    </div>
                    <div className='second-line'>
                      <div className='item-museum item-author' title={painting.authorName}>
                        {painting.dynasty}
                        {painting.authorName ? '/' : ''}
                        {painting.authorName}
                      </div>
                      <div className='item-museum item-gallery' title={painting.museum}>
                        {painting.museum}
                      </div>
                    </div>
                    <div className='icon-box'>
                      <EyeOutlined
                        style={{
                          color: '#fff',
                          fontSize: 16
                        }}
                      />
                      &nbsp;
                      <CloudDownloadOutlined
                        style={{
                          color: '#fff',
                          fontSize: 16
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        })}
        <div
          className='select-work-list'
          id='select-work-list'
          style={{
            display: showWorkList.length > 1 ? 'flex' : 'none'
          }}
        >
          <SelectWorkList
            showWorkList={showWorkList}
            listSize={4}
            setComponent={props.setComponent}
            type={1}
          />
        </div>
      </div>
    </>
  )
}
